import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { ISeedProductsContextValue } from './types';

export default createContext<ISeedProductsContextValue>({
  state: initialState,
  actions: initialActionsState,
  selectors: initialSelectors,
});
